// extracted by mini-css-extract-plugin
export default {"signature-box":"XLyZ-"};